import { FC } from 'react'
import { Box, Button, Typography } from '@mui/material'
import { constants, mappingStatus } from './Constants'

interface DeviceMappingStatusProps {
  categoryType: string | null
  handleClose: () => void
}
const DeviceMappingStatus: FC<DeviceMappingStatusProps> = ({
  categoryType,
  handleClose,
}) => {
  return (
    <>
      {categoryType === mappingStatus?.ipd && (
        <Typography id='device-mapped-to-bed'>
          {mappingStatus?.ipdStatus}
        </Typography>
      )}
      {categoryType === mappingStatus?.location && (
        <Typography id='device-mapped-to-location'>
          {mappingStatus?.locationStatus}
        </Typography>
      )}
      {categoryType === mappingStatus?.ambulance && (
        <Typography id='device-mapped-to-ambulance'>
          {mappingStatus?.ambulanceStatus}
        </Typography>
      )}
      {categoryType === mappingStatus?.homekare && (
        <Typography id='device-mapped-to-homekare'>
          {mappingStatus?.homekareStatus}
        </Typography>
      )}
      {categoryType && (
        <Box display='flex' justifySelf='flex-end' maxWidth={200}>
          <Button onClick={handleClose}>{constants?.close}</Button>
        </Box>
      )}
    </>
  )
}

export default DeviceMappingStatus
